import axios from 'axios';
import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const getDashboardData = async (data: any, DashboardAttendance: any) => {
	const requestData = {
		fetchSectionWiseDataToken: data,
	};
	if (DashboardAttendance == 'DashboardAttendanceDetailsforAll') {
		const URL = `${API_URL}DashboardAttendanceDetailsforAll`;
		console.log('Dashboard API URL:', URL);
		console.log('Dashboard Request params:', data);
		return makeApiCall(URL, requestData);
	} else {
		const URL = `${API_URL}DashboardAttendanceDetails`;
		console.log('Dashboard API URL:', URL);
		console.log('Dashboard Request params:', data);
		return makeApiCall(URL, requestData);
	}
};

export const getDashboardDataEnhanced = async (data: any) => {
	const requestData = {
		fetchDashboardEnhancedToken: data,
	};
	const URL = `${API_URL}DashboardAttendanceDetailsEnhanced`;
	console.log('Enhanced Dashboard API URL:', URL);
	console.log('Enhanced Dashboard Request params:', requestData);
	return makeApiCall(URL, requestData);
};

export const getDashboardEmployeeListEnhanced = async (data: any) => {
	const requestData = {
		fetchEmployeeListEnhancedKeyToken: data,
	};
	const URL = `${API_URL}DashboardEmployeeListEnhanced`;
	console.log('Enhanced Employee List API URL:', URL);
	console.log('Enhanced Employee List Request params:', requestData);
	return makeApiCall(URL, requestData);
};

export const getSectionListForDashboard = () => {
	const URL = `${API_URL}DashboardGetAllSection`;
	console.log(URL);
	return axios.get(URL);
};
